export default [
  {
    path: "collections",
    name: "collections",
    component: () => import("../../views/collections/index.vue"),
    meta: {
      permission: "show_all_collections",
    },
  },
  {
    path: "collection/create",
    name: "create_collection",
    component: () => import("../../views/collections/create.vue"),
    meta: {
      permission: "create_collections",
    },
  },
  {
    path: "collections/:id",
    name: "show_collection",
    component: () => import("../../views/collections/show.vue"),
    meta: {
      permission: "show_single_collections",
    },
  },
];
